export function toFixed(value: number, digits: number = 2): number {
	const pow = Math.pow(10, digits);
	return ~~(value * pow) / pow;
}